import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    Mutable
} from "../../../../types";
import type {
    AttachmentContextType
} from "../../type";
import {
    getElevationStyle
} from "../../../../helpers/theme/elevation";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";

export const ATTACHMENT_VERTICAL_MEDIA_RATIO = 1;

const stylesheet = StyleSheet.create({
    center: {
        ...StyleSheet.absoluteFill,
        justifyContent: "center",
        alignItems: "center"
    },
    fill: {
        ...StyleSheet.absoluteFill
    },
    container: {
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        flexShrink: 0
    },
    disc: {
        justifyContent: "center",
        alignItems: "center",
        position: "absolute"
    },
    badge: {
        position: "absolute"
    }
});

export const useStyles = ({
    shapeConfigs,
    shadowAlpha,
    elevations,
    context,
    spaces,
    colors
}: {
    spaces: NCoreUIKit.ActivePalette["spaces"];
    colors: NCoreUIKit.ActivePalette["colors"];
    shapeConfigs: NCoreUIKit.ShapeConfigs;
    elevations: NCoreUIKit.Elevations;
    context: AttachmentContextType;
    shadowAlpha: number;
}) => {
    const styles = {
        disc: {
            height: context.currentSize.mediaSize + spaces.spacingXs * 2,
            width: context.currentSize.mediaSize + spaces.spacingXs * 2,
            backgroundColor: context.currentColors.containerColor,
            borderRadius: context.currentSize.mediaSize
        } as Mutable<ViewStyle>,
        container: {
            backgroundColor: context.currentColors.mediaColor,
            ...getCornerStyle({
                radius: context.mediaBorderRadius,
                shapeConfigs
            })
        } as Mutable<ViewStyle>,
        badge: {
            bottom: spaces.spacingSm,
            end: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    if(context.orientation === "vertical") {
        Object.assign(styles.container, {
            aspectRatio: ATTACHMENT_VERTICAL_MEDIA_RATIO,
            alignSelf: "stretch"
        });

        Object.assign(styles.disc, getElevationStyle({
            shadowColor: colors.system.shadow,
            level: "level1",
            shadowAlpha,
            elevations
        }));
    }

    if(context.orientation === "horizontal") {
        Object.assign(styles.container, {
            height: context.currentSize.mediaSize,
            width: context.currentSize.mediaSize
        });
    }

    return styles;
};
export default stylesheet;
